module.exports = __webpack_public_path__ + "img/t_0040.1f69d049.gif";